//Šis fails paredzēts pašu rakstīto skriptu pievienošanai.

jQuery(document).ready(function (e) {
    var sidebar_childs = e("#sidebar aside").children().length;
    if (sidebar_childs === 0) {
        e('#content').css('width', '100%');
        e('#sidebar').css('width', '0');
    }

});

function replaceMainBanner() {
    jQuery('.main-banner').css({
        'position': 'fixed',
        'z-index': 100,
        'bottom': 0,
        'border-top': '2px solid #ddd',
        'margin': '0'
    });
    jQuery('.site-footer').css({
        'margin-bottom': '80px'
    });
}
function resetMainBanner() {
    jQuery('.main-banner').css({
        'position': 'relative',
        'z-index': 100,
        'bottom': '',
        'border-top': '',
        'margin': 'initial'
    });
    jQuery('.site-footer').css({
        'margin-bottom': '0px'
    });
}

jQuery(document).ready(function (e) {
    e('.toggle-field div:nth-child(1)').on('click', function () {
        e(this).parent().find('div:nth-child(2)').slideToggle(300);
    });

    autoSubmitStipendijas();
});

function autoSubmitStipendijas() {
    jQuery('#edit-stipendijas-veids').on('change', function () {
        console.log("selected " + this.value);
        if (this.value == "Starptautiskā stipendija") {
            window.open('http://www.viaa.gov.lv/lat/starpt_fin_intrumenti/stipendijas/stipendiju_piedavajumi/', '_blank');
        } else {
            jQuery('#views-exposed-form-stipendijas-page-2').submit();
        }
    });

    jQuery('#edit-fakultate').on('change', function () {
        console.log("selected " + this.value);
        jQuery('#views-exposed-form-stipendijas-page-2').submit();
    });
}
